import React from 'react'
import BaseComponent from './BaseContainer'
import { withApollo, compose, graphql } from 'react-apollo'
import { Redirect } from 'react-router'
import getRoles from '../apollo/graphql/getRoles'
import getUser from '../apollo/graphql/user/get'
import getUsers from '../apollo/graphql/user/getUsers'
import updateUser from '../apollo/graphql/user/update'
import createUser from '../apollo/graphql/user/create'
import deleteUser from '../apollo/graphql/user/delete'
import UserForm from '../components/form/User'

class UserContainer extends BaseComponent {

  constructor(props) {
    super(props)

    const isNew = props.match.params.userId === 'new' || props.match.params.userId === undefined

    this.state = {
      status: {
        loading: true,
        message: null,
        error: null,
        isNew: isNew,
        deletion: { confirm: false }
      },
      user: {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        password2: '',
        roles: []
      },
      roles: []
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
  }

  componentDidMount() {
    if (!this.state.status.isNew) {
      this.props.client.query({
        query: getUser,
        variables: { id: this.props.match.params.userId },
      }).then(({ data }) => {
        if (getUser.error) {
          this.setState({
            status: {
              ...this.state.status,
              error: true, message: getUser.error.message
            }
          })
        }
        let newState = {
          ...this.state
        }
        newState.user = {...data.getUser}
        newState.user.roles = [...data.getUser.roles]
        newState.status.loading = false
        this.setState(newState)
      })
    } else {
      this.setState({
        ...this.state,
        status: {
          ...this.state.status,
          loading: false
        }
      })
    }
  }

  handleChange(event, data, obj) {
    let newState = {
      user: {
        ...this.state.user
      }
    }

    if (obj) {
      newState.user.roles = [{ id: data.value }]
    } else {
      newState.user[event.target.id] = event.target.value
    }
    this.setState(newState)
  }

  handleSubmit(event) {
    event.preventDefault()

    this.setState({
      status: {
        ...this.state.status,
        loading: true
      }
    })

    let newObj = {
      ...this.state.user
    }
    delete newObj.roles
    newObj.roles = []
    const roles = this.state.user.roles
    for (let role of roles) {
      newObj.roles.push({id: role.id})
    }
    this.state.status.isNew ?
      this.props.createUser({
        variables: {
          ...newObj
        }
      }).then((data) => {
        this.setState({
          status: {
            ...this.state.status,
            loading: false,
            message: `Création effectuée le ${new Date(Date.now()).toLocaleString()}`,
            isNew: false
          },
          user: {
            ...this.state.user,
            id: data.data.createUser.id
          },
          redirect: true
        })
      }).catch((error) => {
        this.setState({
          status: {
            ...this.state.status,
            loading: false,
            message: error.message,
            error: true,
            isNew: true
          }
        })
      }) :
      this.props.updateUser({
        variables: {
          ...newObj
        }
      }).then(this.setState({
        status: {
          ...this.state.status,
          loading: false,
          message: `Sauvegarde effectuée le ${new Date(Date.now()).toLocaleString()}`
        },
        redirect: true
      })).catch((error) => {
        this.setState({
          status: {
            loading: false,
            message: error.message,
            error: true
          }
        })
      })
  }

  handleDelete(event, data) {
    event.preventDefault()
    let newState = {
      status: {
        ...this.state.status,
        deletion: {}
      }
    }
    switch (data.confirm) {
    case true:
      newState.status.deletion.confirm = true
      break
    case null:
      newState.status.deletion.confirm = false
      break
    case false:
      newState.status.deletion.confirm = false
      this.props.deleteUser({variables: {id: this.state.user.id}}).then(
        this.props.history.push('/users')
      ).catch((error) => {
        this.setState({
          status: {
            ...this.state.status,
            loading: false,
            message: error.message,
            error: true
          }
        })
      })
      break
    default:
      break
    }
    this.setState(newState)
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to='/users'/>
    }

    if (this.state.status.loading) {
      return <div>Chargement</div>
    }

    return <UserForm
      user={this.state.user}
      roles={this.props.roles}
      status={this.state.status}
      onChange={this.handleChange}
      onSubmit={this.handleSubmit}
      onDelete={this.handleDelete} />
  }
}

const UserContainerEnhanced = compose(
  graphql(getRoles, { name: 'roles' }),
  graphql(updateUser, { name: 'updateUser' }),
  graphql(createUser, { name: 'createUser' }),
  graphql(deleteUser, { name: 'deleteUser',
    options: {
      update: (proxy, { data }) => {
        const users = proxy.readQuery({ query: getUsers })
        users.getUsers = users.getUsers.filter(obj => obj.id !== data.deleteUser.id)
        proxy.writeQuery({ query: getUsers, data: users })
      }
    }
  })
)(UserContainer)

export default withApollo(UserContainerEnhanced)



// WEBPACK FOOTER //
// ./src/containers/UserContainer.js